import {
  EMAIL_NOT_CONNECTED_MESSAGE,
  EMAIL_OPENING_MESSAGE,
  EMAIL_OPENING_SPAM_MESSAGE,
  EMAIL_UNAVAILABLE_MESSAGE,
} from "./emailProviderTypes";
import { resolveActiveEmailProvider } from "./providers/resolveActiveEmailProvider";

/**
 * Provider-neutral email facade for Ashley.
 * Ashley → EmailService → active EmailProvider (Gmail Phase 1).
 */
export const EmailService = {
  /** @returns {Promise<import("./emailProviderTypes").EmailSummaryResult>} */
  async summarizeRecent(options = {}) {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    return provider.summarizeRecent(options);
  },

  /** @returns {Promise<import("./emailProviderTypes").EmailSummaryResult>} */
  async reviewAllUnread(options = {}) {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    if (typeof provider.reviewAllUnread !== "function") {
      return {
        success: false,
        code: "email_unavailable",
        message: EMAIL_UNAVAILABLE_MESSAGE,
      };
    }
    return provider.reviewAllUnread(options);
  },

  /** @returns {Promise<import("./emailProviderTypes").EmailSummaryResult>} */
  async checkSpamAttention() {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    if (typeof provider.checkSpamAttention !== "function") {
      return {
        success: false,
        code: "email_unavailable",
        message: EMAIL_UNAVAILABLE_MESSAGE,
      };
    }
    return provider.checkSpamAttention();
  },

  /** @returns {Promise<import("./emailProviderTypes").EmailSummaryResult & { bodyText?: string }>} */
  async getMessageDetail(messageId) {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    if (typeof provider.getMessageDetail !== "function") {
      return {
        success: false,
        code: "email_unavailable",
        message: EMAIL_UNAVAILABLE_MESSAGE,
      };
    }
    return provider.getMessageDetail(messageId);
  },

  /** @returns {Promise<import("./emailProviderTypes").EmailOpenResult>} */
  async openMessage(messageId) {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    if (typeof provider.openMessage === "function") {
      return provider.openMessage(messageId);
    }
    return provider.openInbox();
  },

  /** @returns {Promise<import("./emailProviderTypes").EmailOpenResult>} */
  async openInbox() {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    return provider.openInbox();
  },

  /** @returns {Promise<import("./emailProviderTypes").EmailOpenResult>} */
  async openSpam() {
    const provider = await resolveActiveEmailProvider();
    if (!provider) {
      return {
        success: false,
        code: "email_not_connected",
        message: EMAIL_NOT_CONNECTED_MESSAGE,
      };
    }
    if (typeof provider.openSpam !== "function") {
      return {
        success: false,
        code: "email_unavailable",
        message: EMAIL_UNAVAILABLE_MESSAGE,
      };
    }
    return provider.openSpam();
  },
};

export {
  EMAIL_NOT_CONNECTED_MESSAGE,
  EMAIL_OPENING_MESSAGE,
  EMAIL_OPENING_SPAM_MESSAGE,
  EMAIL_UNAVAILABLE_MESSAGE,
};
